import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    minHeight: theme.spacing(15.375),
    backgroundColor: theme.palette.gray.dark,
    borderRadius: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    height: theme.spacing(3.75),
    width: theme.spacing(3.75),
  },
}));
